import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenOrtManuelService } from 'libs/gen/src/lib/services/moduls-manuel-services/ort/gen-ort-manuel.service';
import {
  GetGorevSayac_Request,
  GorevSayacDto,
} from '../../../models/ortak.dtos';
import { DkNavService } from '../../../services/dk-nav.service';
import { NotiSayacTur } from '../../../enums/noti-sayac-tur.enum';
import { take } from 'rxjs';

@Component({
  selector: 'dk-side-notification-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dk-side-notification-menu.component.html',
  styleUrls: ['./dk-side-notification-menu.component.scss'],
})
export class DkSideNotificationMenuComponent {
  @Input() notifOpened: boolean = window.innerWidth >= 1024;

  hoveredButton: any = null;

  buttons: GorevSayacDto[];

  showNotiDetail: boolean = false;

  constructor(
    public ortManuelService: GenOrtManuelService,
    private navService: DkNavService
  ) {}

  ngOnInit() {
    setInterval(this.getGorevList.bind(this), 120000);
  }

  ngAfterViewInit() {
    this.getGorevList();
  }

  async getGorevList() {
    const res = await this.ortManuelService.GetGorevSayac_Request(
      new GetGorevSayac_Request({ sayacTur: NotiSayacTur.Tum })
    );
    if (res?.response?.result) {
      this.buildNotificationButtons(res?.response?.gorevSayacList);
    }
  }

  buildNotificationButtons(gorevList: any) {
    this.buttons = gorevList;
  }

  buttonClick(button: any) {
    this.navService.pages$.pipe(take(1)).subscribe((pages) => {
      pages.forEach((page:any) => {
        if(page){
          if (page?.path === button?.url) {
            this.navService.closeButtonHandler(page);
          }
        }
        
      });
    });

    this.navService.addButtonHandler({
      path: button?.url,
      text: button?.formName,
      data: { notiType: button?.aciklama },
    });
    this.showNotiDetail = false;
  }
}
